// Recovered compiled webpack factory 45385. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { H: () => l });
  var n = i(92419);
  function s(t, e) {
    return e.max === e.min ? 0 : (t / (e.max - e.min)) * 100;
  }
  let r = {
    correct: (t, e) => {
      if (!e.target) return t;
      if ("string" == typeof t)
        if (!n.px.test(t)) return t;
        else t = parseFloat(t);
      let i = s(t, e.target.x),
        r = s(t, e.target.y);
      return `${i}% ${r}%`;
    },
  };
  var o = i(24888),
    a = i(39361);
  let l = {
    borderRadius: {
      ...r,
      applyTo: [
        "borderTopLeftRadius",
        "borderTopRightRadius",
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
      ],
    },
    borderTopLeftRadius: r,
    borderTopRightRadius: r,
    borderBottomLeftRadius: r,
    borderBottomRightRadius: r,
    boxShadow: {
      correct: (t, { treeScale: e, projectionDelta: i }) => {
        let n = o.f.parse(t);
        if (n.length > 5) return t;
        let s = o.f.createTransformer(t),
          r = +("number" != typeof n[0]),
          l = i.x.scale * e.x,
          h = i.y.scale * e.y;
        ((n[0 + r] /= l), (n[1 + r] /= h));
        let u = (0, a.k)(l, h, 0.5);
        return (
          "number" == typeof n[2 + r] && (n[2 + r] /= u),
          "number" == typeof n[3 + r] && (n[3 + r] /= u),
          s(n)
        );
      },
    },
  };
}
